'use client';

import { useTranslations } from 'next-intl';

interface LogoTitleProps {
  theme: 'default' | 'white';
}

const LogoTitle = ({ theme }: LogoTitleProps) => {
  const t = useTranslations('logo');
  const textColor = theme === 'default' ? 'text-secondary-navy' : 'text-white';
  return (
    <>
      <p
        className={`${textColor} font-semibold text-[clamp(10px,calc(0.9375vw-2px),16px)] whitespace-nowrap hidden header-3xl:block`}
      >
        {t('title')}
      </p>
      <div className="block header-3xl:hidden">
        <p
          className={`${textColor} font-semibold text-[clamp(10px,calc(0.9375vw-2px),16px)] whitespace-nowrap`}
        >
          {t('moTitle.0')}
        </p>
        <p
          className={`${textColor} font-semibold text-[clamp(10px,calc(0.9375vw-2px),16px)] whitespace-nowrap`}
        >
          {t('moTitle.1')}
        </p>
      </div>
    </>
  );
};
export default LogoTitle;
